'use client';

import Link from 'next/link';

export default function TaxDocRequestSection() {
  return (
    <section
      id="tax-document-request"
      className="relative overflow-hidden section-spacing scroll-mt-20 md:scroll-mt-0 mt-2"
    >
      <div className="relative container-wrap">
        <h2 className="md:text-center xl:text-[54px] lg:text-[48px] sm:text-[40px] text-[26px] leading-[1em] font-semibold text-[#323232] 2xl:mb-10.5 lg:mb-8 md:mb-6 mb-5 md:max-w-none max-w-[70%]">
          990 Tax Document Request
        </h2>
        <p className="text-base lg:text-lg leading-[1.5] text-[#626262]">
          To review our latest financial filings and impact, please complete our{' '}
          <Link href="/contact?s=t" className="underline">
            990 Document Request
          </Link>
          .
        </p>
      </div>
    </section>
  );
}
